module.exports = __webpack_public_path__ + "img/head.46ac3d2a.png";